import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1dc22a81"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-info" }
const _hoisted_2 = {
  key: 0,
  class: "device-list"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "请选择购买意外机损保险的设备", -1))
const _hoisted_4 = { class: "list-wrap" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  class: "empty-info"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "当前账号暂无设备，请先绑定设备或", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "添加为设备使用人。", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 0,
  class: "xag-page__footer footer nongfu-button-wrap"
}

import { useRouter } from 'vue-router'
import { Button, PullRefresh } from 'vant'
import { getActiveTimeInfo } from '../common'
import { commonErrorHandle } from '@/utils/error-handle'
import { CachePinanOrderPayed } from '@/config/insurance'
import { showToastLoading, clearToast } from '@/utils/tools'
import { getJijiaInsuranceDeviceList } from '@/apis/insurance'
import { useInsuranceStore } from '@/compositions/insurance/index'
import { computed, Ref, ref, onActivated, nextTick, onDeactivated, onMounted } from 'vue'
import { usePinanPay, useMultiplatformOrderAdaptation } from '@/compositions/insurance/usePay'
import {
  JijiaDeviceCardInfoListItem,
  JijiaInsranceAppletsValue,
  TestDeviceResult,
} from '@/types/insurance'
import dayjs from 'dayjs'
import AppHeader from '@/components/Header.vue'
import DeviceCardInfo from '../components/device-card-info.vue'
import AutoCheck from '../components/device-verify/auto-check.vue'
import BeforeCheck from '../components/device-verify/before-check.vue'
import ElectronicComponentsRecord from '../components/device-verify/electronic-components-record.vue'


import { defineComponent } from 'vue'
const __default__ = defineComponent({
  name: 'insurance-jijia-device-select',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const loading = ref(false)
const refreshing = ref(false)
const showPopup = ref(false)
const $router = useRouter()
const beforeCheckVisible = ref(false)
const autoCheckVisible = ref(false)
const electronicKey = ref(Date.now())
const electronicComponentsRecordVisible = ref(false)
const testDeviceData: Ref<TestDeviceResult | null> = ref(null)
const deviceList: Ref<JijiaDeviceCardInfoListItem[]> = ref([])
const { removeInsuranceFormPageKeepAlive } = useInsuranceStore()
let nextHandleFn = function () {
  console.log('1', 1)
}
let isFirst = true
const { payHandle } = usePinanPay()
const { payLinkAdaptationJudge } = useMultiplatformOrderAdaptation()
const snPinanInfoMap: Record<
  string,
  {
    policy_no: string // 保单号（最新那份）
    pay_link: string // 支付链接（此值不为空则显示【前往支付】）
    created_at: string // 创建时间
    policy_start_at: string // 保单生效时间
    id: number // 保单id
    is_applets: JijiaInsranceAppletsValue
  }
> = {}
const currentSelectItem = computed(() => {
  return deviceList.value.filter((item) => item.checked)[0]
})
const currentSelectSn = computed(() => {
  return currentSelectItem.value ? currentSelectItem.value.sn : ''
})
function checkClick(data: JijiaDeviceCardInfoListItem) {
  const checkedValue = data.checked
  data.checked = !checkedValue
  if (data.checked) {
    deviceList.value.forEach((item) => {
      item.checked = item.sn === data.sn
    })
  }
}
function showPopupHandle() {
  $router.push({
    name: 'insurance-jijia-insurance-form-page',
    query: {
      sn: currentSelectSn.value,
    },
  })
}
function toPayHandle(data: JijiaDeviceCardInfoListItem) {
  const payLink = snPinanInfoMap[data.sn]?.pay_link
  const policy_start_at = snPinanInfoMap[data.sn]?.policy_start_at
  const created_at = snPinanInfoMap[data.sn]?.created_at
  const id = snPinanInfoMap[data.sn]?.id
  const is_applets = snPinanInfoMap[data.sn]?.is_applets
  const params = {
    pay_link: payLink,
    eq_sn: data.sn,
    effect_time: policy_start_at,
    created_at,
    id,
    from: 'deviceList',
    is_applets,
  }
  if (!payLinkAdaptationJudge(params)) {
    return
  }
  if (!payLink) {
    return
  }
  payHandle(params)
}
function checkPolicy(data: JijiaDeviceCardInfoListItem) {
  const policyNo = snPinanInfoMap[data.sn]?.policy_no
  if (!policyNo) {
    return
  }
  $router.push({
    name: 'insurance-jijia-insurance-detail',
    query: {
      policy_no: policyNo,
    },
  })
}
function onRefresh() {
  refreshing.value = true
  initDeviceList()
}
async function initDeviceList() {
  loading.value = true
  !refreshing.value && showToastLoading()
  try {
    const data = await getJijiaInsuranceDeviceList()
    deviceList.value = data.map((item) => {
      const useCheckbox = !!item?.xcare.can_by
      const useCustom =
        !useCheckbox && (!!item.pingan_xcare.policy_no || !!item.pingan_xcare.pay_link)
      const result: JijiaDeviceCardInfoListItem = {
        sn: item.eq_sn,
        headInfo: {
          name: item.eq_name,
          mainInfos: [`SN：${item.eq_sn}`],
          img: item.eq_logo,
          sn: item.eq_sn,
          model: item.eq_model_name,
          activeTime: dayjs(item.eq_activate_at * 1000).format('YYYY-MM-DD HH:mm:ss'),
        },
        checked: false,
        useCheckbox,
        // useCheckbox: true,
        useCustom,
        // useCustomPay: useCustom && !!item.pingan_xcare.pay_link,
        useCustomPay: useCustom && !!item.pingan_xcare.pay_link,
        detailInfos: [[`设备型号：${item.eq_model_name}`], getActiveTimeInfo(item.eq_activate_at)],
        tips: item?.xcare.can_by === false ? item?.xcare.message : '',
        hasEquity: !!item.is_exist_equity,
      }
      snPinanInfoMap[item.eq_sn] = item.pingan_xcare
      return result
    })
    clearToast()
  } catch (error) {
    console.log('error', error)
    commonErrorHandle(error)
  }
  loading.value = false
  refreshing.value = false
}
function confirmStartCheckHandle() {
  // 确认开始验机
  beforeCheckVisible.value = false
  nextTick(() => {
    autoCheckVisible.value = true
  })
}

function testSuccessHandle(data: TestDeviceResult) {
  console.log('data', data)
  autoCheckVisible.value = false
  testDeviceData.value = data
  nextTick(() => {
    electronicComponentsRecordVisible.value = true
  })
}
function nextHandle() {
  electronicComponentsRecordVisible.value = false
  nextHandleFn()
}
onActivated(() => {
  console.log('2222', 222)
  removeInsuranceFormPageKeepAlive()
  if (isFirst) {
    isFirst = false
    return
  }
  const cacheValue = sessionStorage.getItem(CachePinanOrderPayed)
  if (cacheValue && cacheValue === '1') {
    // 隐藏弹窗并更新列表
    showPopup.value = false
    initDeviceList()
    sessionStorage.removeItem(CachePinanOrderPayed)
  }
  console.log('222', cacheValue)
})
onDeactivated(() => {
  beforeCheckVisible.value = false
  autoCheckVisible.value = false
  //showPopup.value = false
  //electronicComponentsRecordVisible.value = false
  setTimeout(() => {
    electronicComponentsRecordVisible.value = false
    electronicKey.value = Date.now()
  }, 500)
})
void initDeviceList()

// setTimeout(() => {
//   giveUpPopupShow.value = true
// }, 1000)
// setTimeout(() => {
//   giveUpPopupShow.value = true
// }, 5000)
onMounted(() => {
  // 如果不适用keepalive了  这里需要启用
  // removeInsuranceFormPageKeepAlive()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "选择设备" }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(PullRefresh), {
        modelValue: refreshing.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((refreshing).value = $event)),
        onRefresh: onRefresh
      }, {
        default: _withCtx(() => [
          ((!loading.value || refreshing.value) && deviceList.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _hoisted_3,
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deviceList.value, (item) => {
                    return (_openBlock(), _createBlock(DeviceCardInfo, {
                      onCheckClick: checkClick,
                      key: item.sn,
                      round: "",
                      data: item,
                      imgSize: 64
                    }, {
                      customRight: _withCtx(({ data }) => [
                        (data.useCustom && !data.useCustomPay)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "check-detail-btn",
                              onClick: ($event: any) => (checkPolicy(data))
                            }, " 查看保单 ", 8, _hoisted_5))
                          : _createCommentVNode("", true),
                        (data.useCustomPay)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "pay-btn",
                              onClick: ($event: any) => (toPayHandle(data))
                            }, " 前往支付 ", 8, _hoisted_6))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["data"]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (!loading.value && deviceList.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    ((!loading.value || refreshing.value) && deviceList.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(_unref(Button), {
            class: "confirm-button xa-vant-button",
            round: "",
            onClick: showPopupHandle,
            disabled: !_unref(currentSelectItem)
          }, {
            default: _withCtx(() => [
              _createTextVNode("下一步")
            ]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(BeforeCheck, {
      show: beforeCheckVisible.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((beforeCheckVisible).value = $event)),
      onConfirmStart: confirmStartCheckHandle
    }, null, 8, ["show"]),
    _createVNode(AutoCheck, {
      show: autoCheckVisible.value,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((autoCheckVisible).value = $event)),
      sn: _unref(currentSelectItem)?.sn,
      onTestSuccess: testSuccessHandle
    }, null, 8, ["show", "sn"]),
    (_openBlock(), _createBlock(ElectronicComponentsRecord, {
      show: electronicComponentsRecordVisible.value,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((electronicComponentsRecordVisible).value = $event)),
      data: testDeviceData.value,
      onNext: nextHandle,
      key: electronicKey.value
    }, null, 8, ["show", "data"]))
  ], 64))
}
}

})